import React from 'react'
import { useRecoilValue } from 'recoil'

import OnboardingWizard from '../components/onboarding/OnboardingWizard'
import { sessionState } from '../state'

/**
 * OnboardingPage - Page component that renders the OnboardingWizard
 *
 * This page is accessible at /onboarding and provides the onboarding
 * wizard flow for new users who need to set up their account.
 *
 * Requirements: 2.5, 9.2, 9.5
 */
const OnboardingPage: React.FC = () => {
  const session = useRecoilValue(sessionState)

  // If no user is authenticated, show a message
  if (!session.user) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h2>Please sign in to continue</h2>
        <p>You need to be signed in to access the onboarding wizard.</p>
      </div>
    )
  }

  return <OnboardingWizard user={session.user} />
}

export default OnboardingPage
